(function () {
  function movePayStrip() {
    const strip = document.getElementById("rs-pay-strip");
    if (!strip) return;

    // Selector típico en Dawn para el bloque de botones
    const buttons =
      document.querySelector(".product-form__buttons") ||
      document.querySelector("product-form .product-form__buttons") ||
      document.querySelector("product-form");

    if (!buttons) return;

    // Estilos por si el tema lo modifica
    strip.style.display = "flex";
    strip.style.justifyContent = "center";
    strip.style.marginTop = "10px";

    // Mover justo debajo del bloque de botones
    buttons.insertAdjacentElement("afterend", strip);
  }

  // Intento inmediato + reintentos por si Shopify carga dinámico
  function runWithRetries() {
    movePayStrip();
    setTimeout(movePayStrip, 200);
    setTimeout(movePayStrip, 600);
    setTimeout(movePayStrip, 1200);
  }

  document.addEventListener("DOMContentLoaded", runWithRetries);
  document.addEventListener("shopify:section:load", runWithRetries);
  document.addEventListener("shopify:section:select", runWithRetries);
  document.addEventListener("shopify:block:select", runWithRetries);
})();
